import { render, staticRenderFns } from "./statistical-analysis-view-detail-table-grouping.vue?vue&type=template&id=2bf58fec&scoped=true&"
import script from "./statistical-analysis-view-detail-table-grouping.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-view-detail-table-grouping.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-view-detail-table-grouping.scss?vue&type=style&index=0&id=2bf58fec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf58fec",
  null
  
)

export default component.exports